export var HitResultType;
(function (HitResultType) {
    HitResultType[HitResultType["segment"] = 0] = "segment";
    HitResultType[HitResultType["stroke"] = 1] = "stroke";
})(HitResultType || (HitResultType = {}));
export default class HitResult {
    constructor(type, segment, point, location) {
        this.type = type;
        this.segment = segment;
        this.location = location;
        this.point = point;
    }
}
//# sourceMappingURL=hit_result.js.map